import { createFileRoute } from "@tanstack/react-router";
import { TeacherLoginPage } from "@/projects/teacher/pages/LoginPage";

export const Route = createFileRoute("/login/teacher")({
  head: () => ({
    meta: [{ title: "Teacher Login — રાજનગર જ્ઞાનોત્સવ 2.0" }],
  }),
  component: TeacherLoginPage,
});
